import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { NavigationService } from 'src/app/services/navigation.service';
import { CustomerRequestDataService } from 'src/app/services/customer-request-data.service';
import { LoaderService } from 'src/app/shared/services/loader.service';
import { UserdataService } from 'src/app/services/userdata.service';
import { LookupDataServiceService } from 'src/app/services/lookup-data-service.service';
import { forkJoin } from 'rxjs';
import { RegisterDataService } from 'src/app/services/register-data.service';
import { NotificationService } from 'src/app/services/notification-service';
import { ProductService } from 'src/app/services/product.service';

@Component({
  selector: 'app-manage-sub-Categ-add',
  templateUrl: './manage-sub-Categ-add.component.html',
  styleUrls: ['./manage-sub-Categ-add.component.scss']
})
export class AddManageSubCategComponent implements OnInit {
  form: FormGroup;
  paramsid: any;
  title: any;
  PtoductList: any = [];
  ConnectionList: any = [];
  filterPtoductList: any = [];
  filterConnectionList: any = [];

  constructor(private navigate: NavigationService,
    private fb: FormBuilder,
    public dialog: MatDialog,
    private productService: ProductService,
    private activateroute: ActivatedRoute,
    private lookupdataservice: LookupDataServiceService,
    private toastr: NotificationService
  ) {
    this.activateroute.params.subscribe((params: any) => {
      this.paramsid = parseInt(params.id);
    });
  }

  ngOnInit(): void {
    this.initializeValidators();
    forkJoin({
      productCateg: this.lookupdataservice.getProductCategoryType(),
      connectionType: this.lookupdataservice.getConnectionFeeType(true)
    }).subscribe(
      responses => {
        this.filterPtoductList = responses.productCateg;
        this.PtoductList = this.filterPtoductList.slice();
        this.filterConnectionList = responses.connectionType;
        this.ConnectionList = this.filterConnectionList.slice();
      })
    if (this.paramsid > 0) {
      this.getFormDetails();
    }
  }

  initializeValidators() {
    this.form = this.fb.group({
      productCategoryType: [null, [Validators.required]],
      subCategoryName: ['', [Validators.required, Validators.pattern(/\S/)]],
      connectionFeeType: [null, [Validators.required]],
      productCategoryId: [0]
    });
  }

  getFormDetails() {
    this.productService.getAllProductSubCategory().subscribe((res) => {
      debugger
      res = res.filter(v => v.id === this.paramsid);
      this.form.patchValue({
        ...res[0],
        productCategoryId: res[0].id
      });
    });
  }

  gotoProductSub() {
    this.navigate.gotoProductSub();
  }

  onsubmit() {
    if (this.form.valid) {
      let payload = {
        ...this.form.value,
        subCategory: this.form.value.subCategoryName
      }
      this.productService.saveProductSubCategory(payload).subscribe((res) => {
        if (this.paramsid === 0) {
          this.toastr.showSuccess("Saved Successfully");
        } else {
          this.toastr.showSuccess("Updated Successfully");
        }
        this.gotoProductSub();
      });
    } else {
      this.form.markAllAsTouched();
      this.toastr.showError("Please fill in all mandatory fields!")
    }
  }

}
